"use client";

import { Box } from "@chakra-ui/react";
import { useEffect, useState, type RefObject } from "react";
import { useThemeTokens } from "@/lib/theme/tokens";
import { ClassRegisterCta } from "./ClassRegisterCta";

interface ClassStickyRegisterBarProps {
  heroCtaRef: RefObject<HTMLElement | null>;
  classId: number;
  allowOnlineRegistration?: boolean | null;
}

export const ClassStickyRegisterBar = ({
  heroCtaRef,
  classId,
  allowOnlineRegistration,
}: ClassStickyRegisterBarProps) => {
  const theme = useThemeTokens();
  const [showBar, setShowBar] = useState(false);

  useEffect(() => {
    const target = heroCtaRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => setShowBar(!entry.isIntersecting),
      { threshold: 0, rootMargin: "0px 0px -24px 0px" },
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, [heroCtaRef]);

  if (!showBar) return null;

  return (
    <Box
      display={{ base: "block", md: "none" }}
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      zIndex={20}
      px={4}
      py={4}
      bg={theme.bg.primary}
      borderTopWidth="1px"
      borderColor={theme.borderGlass.default}
      boxShadow="0 -8px 24px rgba(0, 0, 0, 0.12)"
    >
      <ClassRegisterCta
        classId={classId}
        allowOnlineRegistration={allowOnlineRegistration}
        variant="sticky"
      />
    </Box>
  );
};
